import { Injectable } from '@angular/core';
import { NetworkUtilsService, URL_DICT } from 'projects/app-core/src/service/network-utils.service';
import { CreateOrUpdateMasterDataConfigBody, ListMasterDataConfigsResponse, FieldSpec, MasterDataCategoryV2 } from '../models/master-data-config';

@Injectable({ providedIn: 'root' })
export class MasterDataConfigService {
  constructor(private api: NetworkUtilsService) {}

  createOrUpdateMasterDataConfig(body: CreateOrUpdateMasterDataConfigBody) {
    return this.api.post(URL_DICT.adminMasterDataConfigCreate, body);
  }

  listAllConfigs() {
    return this.api.get<ListMasterDataConfigsResponse>(URL_DICT.adminMasterDataConfigGetAll);
  }

  getConfigByCategory(category: MasterDataCategoryV2) {
    return this.api.get<{ category: MasterDataCategoryV2; configFeilds: FieldSpec[] }>(
      URL_DICT.adminMasterDataConfigByCategory + category
    );
  }

  createMasterData(body: { category: MasterDataCategoryV2; fields: Record<string, unknown> }) {
    return this.api.post(URL_DICT.adminMasterDataCreate, body);
  }

  listMasterDataByCategory(category: MasterDataCategoryV2) {
    return this.api.get<Array<{ m_id: string; data: string; [key: string]: unknown }>>(
      URL_DICT.adminMasterDataListByCategory + category
    );
  }

  listMasterDataByExperts() {
    return this.api.get<Array<{
        expertId: string;
        userId: string;
        name: string;
      }>>(
      URL_DICT.adminMasterDataExpertList
    );
  }

  getNameByAnyId(anyId: string[]) {
    return this.api.post<Array<{ name: string; id: string }>>(URL_DICT.adminCheckAnyIdGetName,{ ids: anyId});
  }

  getMasterDataCategories() {
    return this.api.get<{categories: string[] , masterDataTypes: string[] , anyoRules : string[]}>(URL_DICT.adminMasterDataCategoryGetUrl);
  }
}


